import { FormValidator, isEmpty, type FormValidatorConfig, type FormValidatorSettings } from '@common/index';
import { getStrippedValue } from '@common/lib/modules/form/utils/validartor.utils';

export interface RequiredOnFinalizeValidatorSettings extends FormValidatorSettings {
  stripTags?: boolean;
}

export type RequiredOnFinalizeValidatorConfig = FormValidatorConfig<RequiredOnFinalizeValidatorSettings>;

export class RequiredOnFinalizeValidator extends FormValidator<RequiredOnFinalizeValidatorSettings> {
  constructor() {
    super();
    this._name = 'requiredOnFinalize';
    this._settings = {
      invalidMessage: 'form.validator.requiredOnFinalize.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any) {
    value = this._settings.stripTags ? getStrippedValue(value) : value;

    this._valid = !isEmpty(value);

    if (!this._valid) {
      this.addMessage(this._settings.invalidMessage);
    }
  }
}
